export const formatOptionLabel = (option: Record<string, any>, template: string): string => {
  if (!template || typeof template !== "string") return option?.label || "";
  return template.replace(/\$\{(\w+)\}/g, (_, key) => (option?.[key] !== undefined ? String(option[key]) : ""));
};
